import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import ReactTooltip from 'react-tooltip';

require("highcharts/modules/exporting")(Highcharts)
require("highcharts/modules/export-data")(Highcharts)
require("highcharts/modules/annotations")(Highcharts)
require("highcharts/highcharts-more.js")(Highcharts)

function RadialAndBarChart({
    categories,
    selectedCat,
    selectedTopic,
    topicID,
    handleChangeSelectedCategory,
    width,
    height,
    showTooltip,
    isBarChart,
    handlePracticeCategorySelect,
    selectedCategories
}) {

    // console.debug("categories-----" ,categories)

    const getDataPoints = (catKey) => {
        let data = categories.map((cat,) => {
            if (cat.key === catKey) {
                return {
                    y: cat.accuracyIndex,
                    color: cat.backgroundColor,
                    selected: selectedCat?.key === cat.key,
                }
            }
            return {
                y: 0,
                color: "red",
            };
        })
        return data;
    }


    return (
        <div className='position-relative'>
            {/* <div className="text-align-center fontClass-18"><b>{selectedTopic?.name}</b>(Topic)</div>
            <div className="text-align-center fontClass-12 mt-2">Categories by Accuracy & Time </div> */}
            <HighchartsReact
                highcharts={Highcharts}
                style={{
                    backgroundColor: "red"
                }}
                options={{
                    // colors: ['#FFD700', '#efefef'],
                    credits: {
                        enabled: false,
                    },
                    navigation: {
                        buttonOptions: {
                            enabled: false
                        }
                    },

                    chart: {
                        // margin: isBarChart ? [] : [0, 0, 40, 0],
                        type: 'column',
                        inverted: true,
                        polar: true,
                        width: 360,
                        height: 350
                    },
                    title: {
                        text: null,
                        align: "center",
                    },
                    tooltip: {
                        outside: true,
                    },
                    pane: {
                        size: "90%",
                        innerSize: "20%",
                        startAngle: 180,
                        endAngle: 180 + 270,
                    },
                    xAxis: {
                        minPadding: 0,
                        maxPadding: 0,
                        title: {
                            text: ''
                        },
                        labels: {
                            enabled: true,
                            align: "right",
                            useHTML: true,
                            allowOverlap: true,
                            step: 0,
                            y: 8,
                            x: 35,
                            style: {
                                fontSize: "12px",
                                textOverflow: 'none',
                            },
                            formatter: (data) => {
                                // console.debug("data===", data.value)
                                if (data?.value.accuracyIndex === undefined) {
                                    return ''
                                }

                                return `<span class='radial-accuracy-label'>${data.value?.accuracyIndex?.toFixed(0)}%</span>`
                            }
                        },
                        lineWidth: 0,
                        gridLineWidth: 0,
                        categories: categories?.map(cat => cat),
                    },
                    yAxis: {
                        labels: {
                            enabled: true,
                        },
                        title: {
                            text: ""
                        },
                        max: 100,
                        lineWidth: 0,
                        tickInterval: 25,
                        reversedStacks: false,
                        endOnTick: true,
                        showLastLabel: true,
                        lineWidth: 0,
                        gridLineWidth: 0,
                    },

                    plotOptions: {
                        column: {
                            stacking: "normal",
                            borderWidth: 0,
                            pointPadding: 0,
                            pointWidth: 12,
                            borderRadius: 6,
                            // groupPadding: 0.8,
                        },
                        bar: {
                            // pointWidth: 20,
                        },
                        series: {
                            // enableMouseTracking: false,
                            states: {
                                select: {
                                    color: null,
                                    borderColor: 'black',
                                    borderWidth: 2
                                },
                                hover: {
                                    color: null,
                                    borderColor: 'black',
                                    borderWidth: 2,
                                },
                                inactive: {
                                    opacity: 1
                                }
                            },
                            point: {
                                events: {
                                    click: function (data) {
                                        let catClicked = data?.point.category;
                                        if (catClicked?.key) {
                                            const index = categories?.findIndex(cat => cat.key === catClicked.key);
                                            handleChangeSelectedCategory(catClicked)
                                        }

                                    }
                                }
                            },
                        }
                    },
                    tooltip: {
                        useHTML: true,
                        formatter: function (data) {
                            // console.debug("data---", data, this.y, this.x)
                            let catName = this.x.label ? this.x.label : this.x.name
                            return `<div style="z-index:999">
                            ${catName} <br/><div><b>Accuracy Index:</b> ${this.x.accuracyIndex.toFixed(0)}</div><div><b>Time:</b> ${this.x.timeInSec}</div>
                        </div>`;
                        },
                        positioner: function () {
                            return { x: 50, y: 50 };
                        },
                        shape: "square",
                        style: {
                            zIndex: 999
                        },
                        // positioner: function(labelWidth, labelHeight, point) {
                        //     var tooltipX = point.plotX;
                        //     var tooltipY = point.plotY;
                        //     return {
                        //         x: tooltipX,
                        //         y: tooltipY
                        //     };
                        // }
                        // shadow: false,
                        // borderWidth: 0,
                        // backgroundColor:'transparent'
                    },

                    // series: categories?.length < 8 ? 
                    // [...Array.from({ length: 8 - (categories.length || 0) }, () => null), ...categories, ].map((cat, catIndex) => {

                    //     if (cat == null) {
                    //         return {
                    //             showInLegend: false,
                    //             allowPointSelect: false,
                    //             name: '',
                    //             color: '#efefef',
                    //             data: [0,0,0,0,0,0,0,0]
                    //         }
                    //     }

                    //     return {
                    //         showInLegend: false,
                    //         allowPointSelect: false,
                    //         name: cat.label ? cat.label : cat.name,
                    //         color: cat.backgroundColor,
                    //         data: getDataPoints(cat.key)
                    //     }
                    // })
                    // : 
                    // categories?.map((cat, catIndex) => {
                    //     console.debug("getDataPoints(cat.key)", getDataPoints(cat.key))
                    //     return {
                    //         showInLegend: false,
                    //         allowPointSelect: false,
                    //         name: cat.label ? cat.label : cat.name,
                    //         color: cat.backgroundColor,
                    //         data: getDataPoints(cat.key)
                    //     }
                    // })



                    series: [
                        {
                            showInLegend: false,
                            allowPointSelect: true,
                            name: "Accuracy Index",
                            data: [
                                ...(categories?.map((cat) => ({
                                    y: cat.accuracyIndex,
                                    color: cat.backgroundColor,
                                    selected: selectedCat?.key === cat.key,
                                })) || []),
                                ...(categories && categories.length < 8
                                    ? Array.from({ length: 8 - (categories.length || 0) }, () => ({
                                        y: 0,
                                        color: "",
                                        selected: false,
                                    }))
                                    : []),
                            ],
                        },
                        {
                            showInLegend: false,
                            allowPointSelect: false,
                            name: "Empty",
                            states: {
                                hover: {
                                    enabled: false,
                                },
                            },
                            data: [
                                ...(categories?.map((cat) => ({
                                    y: 100 - cat.accuracyIndex,
                                    color: "#efefef",
                                    selected: false,
                                })) || []),

                                // UNCOMMENT the following lines to show all the 8 circles irrespective of categories length
                                // ...(categories && categories.length < 8
                                //     ? Array.from({ length: 8 - (categories.length || 0) }, () => ({
                                //         y: 100,
                                //         color: "#efefef",
                                //         selected: false,
                                //     }))
                                //     : []),
                            ],
                            // data: categories?.map((cat) => {
                            //     return {
                            //         y: 100 - cat.accuracyIndex,
                            //         color: "#efefef",
                            //     };
                            // }),
                        },
                    ],
                }}
            />


            <div className='cat-list-pc'>
                {categories?.length < 8 ?
                    [...Array.from({ length: 8 - (categories.length || 0) }, () => null), ...[...categories].reverse(),]
                        .map((cat, index) => {
                            let isCatSelected = selectedCategories.findIndex(selectedCat => selectedCat.key === cat?.key) >= 0;
                            if (cat === null) {
                                return <div key={index} className='single-cat-pc hidden'>h</div>
                            }
                            return <div
                                className="single-cat-pc cursor-pointer py-0 my-0 position-relative"
                                key={cat.key}
                            >
                                {cat !== null && categories[categories.length - 1].key === cat.key ? <div className='add-to-practice-label'>Add to Practice Set</div> : null}
                                <div className="d-flex justify-content-start align-items-center w-100">
                                    <div
                                        onClick={() => {
                                            handleChangeSelectedCategory(cat)
                                        }}
                                        style={{
                                            flex: "0 0 auto",
                                            fontWeight: cat.key === selectedCat.key ? "900" : "",
                                        }}
                                        className='cursor-pointer'
                                    >
                                        {cat.label ? cat.label : cat.name} ({cat.timeInSec} Sec)
                                    </div>
                                    <div style={{ flex: "1 0", height: "1px", background: "#D9D9D9" }}></div>
                                </div>
                                <div >
                                    <ReactTooltip
                                        id={`add_to_practice_set_${cat.key}`}
                                        multiline={true}
                                        place="top"
                                        effect="float"
                                    />
                                    {/* <Checkbox id={index} checked={cat.checked} className="custom-checkbox" onChange={(val) => {
                                    console.debug("val", val)
                                    // handlePracticeCategorySelect(cat, val)
                                }}
                                    data-for={`add_to_practice_set_${cat.key}`}
                                    data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                                /> */}
                                    <input type="checkbox"
                                        className='cursor-pointer'
                                        id={index}
                                        name={cat.key}
                                        checked={isCatSelected}
                                        onChange={event => {
                                            let val = event.target.checked;
                                            // console.debug("val", val)
                                            handlePracticeCategorySelect(cat, val)
                                        }}
                                    />
                                </div>
                            </div>
                        })
                    : [...categories]?.map((cat, index) => {
                        let isCatSelected = selectedCategories.findIndex(selectedCat => selectedCat.key === cat?.key) >= 0;
                        return (
                            <div
                                className="single-cat-pc cursor-pointer py-0 my-0"
                                key={cat.key}
                            >
                                <div className="d-flex justify-content-start align-items-center w-100">
                                    <div
                                        onClick={() => {
                                            handleChangeSelectedCategory(cat)
                                        }}
                                        style={{
                                            flex: "0 0 auto",
                                            fontWeight: cat.key === selectedCat.key ? "900" : "",
                                        }}
                                        className='cursor-pointer'
                                    >
                                        {cat.label ? cat.label : cat.name} ({cat.timeInSec} Sec)
                                    </div>
                                    <div style={{ flex: "1 0", height: "1px", background: "#D9D9D9" }}></div>
                                </div>
                                <div >
                                    <ReactTooltip
                                        id={`add_to_practice_set_${cat.key}`}
                                        multiline={true}
                                        place="top"
                                        effect="float"
                                    />
                                    {/* <Checkbox id={index} checked={cat.checked} className="custom-checkbox" onChange={(val) => {
                                    console.debug("val", val)
                                    // handlePracticeCategorySelect(cat, val)
                                }}
                                    data-for={`add_to_practice_set_${cat.key}`}
                                    data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                                /> */}
                                    <input type="checkbox"
                                        className='cursor-pointer'
                                        id={index}
                                        name={cat.key}
                                        checked={isCatSelected}
                                        onChange={event => {
                                            let val = event.target.checked;
                                            // console.debug("val", val)
                                            handlePracticeCategorySelect(cat, val)
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                {/* {categories?.map((cat, index) => {
                    return (
                        <div
                            className="single-cat cursor-pointer py-0 my-0"
                            key={cat.key}
                        >
                            <div className="d-flex justify-content-center align-items-center w-100">
                                <div
                                    onClick={() => {
                                        // this.changeSelectedCategory(cat)
                                    }}
                                    className="w-100"
                                >
                                    {cat.label ? cat.label : cat.name}
                                </div>
                            </div>
                            <div >
                                <ReactTooltip
                                    id={`add_to_practice_set_${cat.key}`}
                                    multiline={true}
                                    place="top"
                                    effect="float"
                                />
                                <Checkbox id={index} checked={cat.checked} className="custom-checkbox" onChange={(val) => {
                                    console.debug("val", val)
                                    // this.handlePracticeCategorySelect(cat, val)
                                }}
                                    data-for={`add_to_practice_set_${cat.key}`}
                                    data-tip={cat.checked ? "Remove from practice set" : "Add to practice set"}
                                />
                            </div>
                        </div>
                    );
                })} */}
            </div>
        </div>

    );
}

export default RadialAndBarChart
